import { z } from 'zod';

import { VALIDATE } from '@/shared/constants/validation';

export const validateAddPortfolioItemForm = z
  .object({
    clubName: VALIDATE.REQUIRED,
    clubCountry: VALIDATE.REQUIRED,
    startDate: z.date(),
    endDate: z.date().nullable(),
    untilNow: z.boolean(),
    jobRole: VALIDATE.REQUIRED
  })
  .refine(
    (data) =>
      (data.untilNow === true && data.endDate === null) ||
      (data.untilNow === false && data.endDate !== null),
    {
      message: 'select some',
      path: ['endDate']
    }
  );
